import { httpClient } from '@/core/api/httpClient';
import { env } from '@/core/config/env';

export type TenantNotificationCategory = 'information' | 'warning' | 'critical';
export type TenantNotificationType = 'platform-announcement' | 'reservation-requested';

export interface TenantNotification {
  id: string;
  batchId: string;
  tenantId: string;
  tenantName: string | null;
  title: string;
  message: string;
  category: TenantNotificationCategory;
  notificationType: TenantNotificationType;
  audience: 'all-members' | 'managers';
  sentAtUtc: string;
  sentByDisplayName: string;
  viewedAtUtc: string | null;
  viewedByMembershipId: string | null;
  viewedByDisplayName: string | null;
  isViewed: boolean;
}

export interface TenantNotificationInbox {
  unreadCount: number;
  items: TenantNotification[];
}

export const tenantNotificationsApi = {
  list: async (take = 50): Promise<TenantNotificationInbox> => {
    if (env.isDemo) return { unreadCount: 0, items: [] };
    return (await httpClient.get<TenantNotificationInbox>(`/api/v1/tenant-notifications?take=${take}`)).data;
  },

  markViewed: async (notificationId: string): Promise<TenantNotification> =>
    (await httpClient.post<TenantNotification>(`/api/v1/tenant-notifications/${notificationId}/view`)).data,
};
